import {ErrorMessage, Formik} from "formik";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import styled from "styled-components";
import {ROLE_AMBASSADOR, ROLE_CODIR, ROLE_USER} from "../../permissions/roleTypes";
import {DisplayForAmbassador} from "../../permissions/DisplayAccordingToRole";
import * as Yup from "yup";
import {loadUsers, postUser} from "../user/usersAction";
import SendFormButton from "../buttons/SendFormButton";
import {FormFormik, InputTextFormik} from "../inputs/InputStyle";
import useSortItems from "../../custom-hooks/useSortItems";
import TagInput from "../inputs/TagInput";
import useTags from "../../custom-hooks/useTags";

const AddUserModal = ({setModalIsOpen,}) => {


    const dispatch = useDispatch()
    const [selectedRole, setSelectedRole] = useState("")
    const passwordRegexPhrase = "Votre mot de passe doit contenir 12 caractères, une lettre majuscule, un nombre et un caractère spécial"
    const {status} = useSelector(state => state.oneUser)
    const {pushItemsInArray} = useSortItems()

    const {selectedTags, setSelectedTags} = useTags([], null)

    const handleSubmit = async (data) => {
        let newData = {}
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                if (key !== "confirmPassword") {
                    newData[key] = data[key]
                }
            }
        }
        newData.role = selectedRole
        let keyName = "tagId"
        if (selectedTags.length > 0) {
            newData.tags = pushItemsInArray(selectedTags, keyName)
        }
        await dispatch(postUser(newData))
        dispatch(loadUsers())
        setModalIsOpen(false)
    }


    const SignupSchema = Yup.object().shape({
        firstName: Yup.string()
            .max(50, 'Le prénom est trop long')
            .required('Le champs est requis'),
        lastName: Yup.string()
            .max(50, 'Le nom est trop long')
            .required('Le champs est requis'),
        email: Yup.string()
            .email('Email invalide')
            .required('Le champs est requis'),

        plainPassword: Yup.string()
            .min(12, "Mot de passe trop court")
            .max(50, "Mot de passe trop long")
            .required('Veuillez écrire votre mot de passe')
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@().{}/\\'€#"$%^&*+[,:;<=>?_|~`-])(?=.{12,})/,
                passwordRegexPhrase),
        confirmPassword: Yup.string()
            .required('Veuillez confirmer votre mot de passe ')
            .oneOf([Yup.ref('plainPassword'), null], 'Le mot de passe de confirmation ne correspond pas'),

        phone: Yup.string()
    });

    const handleChange = (e) => {
        setSelectedRole(e.target.value)
    }


    const displayRoleOptions = () => {
        return [
            {value: ROLE_USER, label: "Collaborateur"},
            {value: ROLE_AMBASSADOR, label: "Ambassadeur"},
            {value: ROLE_CODIR, label: "Codir"},
        ]
    }


    return (
        <Container>
            <Formik
                initialValues={{
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    plainPassword: '',
                    confirmPassword: '',

                }}
                validationSchema={SignupSchema}
                onSubmit={handleSubmit}
            >

                {() => (
                    <Form>
                        <MainSectionForm>
                            <FullNameSection className={"flex-row "}>
                                <div>
                                    <InputTextFormik
                                        name="firstName"
                                        type={"text"}
                                        placeholder={'Prénom'}
                                    />
                                    <ErrorMessage
                                        name="firstName"
                                        render={msg => <div><p className="error-text"> {msg} </p></div>}
                                    />
                                </div>
                                <div>
                                    <InputTextFormik
                                        name="lastName"
                                        type={"text"}
                                        placeholder={'Nom de famille'}

                                    />
                                    <ErrorMessage
                                        name="lastName"
                                        render={msg => <div><p className="error-text"> {msg} </p></div>}
                                    />
                                </div>

                            </FullNameSection>

                            <InputTextFormik
                                name="email"
                                type="email"
                                placeholder={'Email'}
                            />
                            {(status !== 0 && status.toString().startsWith("5")) &&
                            <p className={'error-text'}> Il semblerait que cet email soit déjà pris </p>}
                            <ErrorMessage
                                name="email"
                                render={msg => <div><p className="error-text"> {msg} </p></div>}/>
                            <InputTextFormik
                                name="phone"
                                type="tel"
                                placeholder={'Téléphone'}
                            />

                            <InputTextFormik
                                name="plainPassword"
                                type="password"
                                placeholder={"Mot de passe"}
                            />
                            <ErrorMessage
                                name="plainPassword"
                                render={msg => <div><p className="error-text"> {msg} </p></div>}
                            />
                            <InputTextFormik
                                name="confirmPassword"
                                type="password"
                                placeholder={"Mot de passe de confirmation"}
                            />
                            <ErrorMessage
                                name="confirmPassword"
                                render={msg => <div><p className="error-text"> {msg} </p></div>}
                            />

                            <ErrorMessage
                                name="phone"
                                render={msg => <div><p className="error-text"> {msg} </p></div>}
                            />
                            <DisplayForAmbassador
                                component={
                                    <InputTextFormik
                                        as="select"
                                        value={selectedRole}
                                        name="roles"
                                        onChange={(e) => handleChange(e)}
                                    >
                                        {displayRoleOptions().map(role => (
                                            <option value={role.value}> {role.label} </option>
                                        ))}
                                    </InputTextFormik>
                                }
                            />
                            <TagInput
                                setSelectedTags={setSelectedTags}
                                selectedTags={selectedTags}
                                actionName={'users'}
                            />
                        </MainSectionForm>
                        <SendFormButton
                            state={true}
                            actionName={"Créer"}
                        />
                    </Form>
                )}
            </Formik>
        </Container>
    )
}

const Form = styled(FormFormik)`
  width: 100%;
  flex-grow: 1;
  justify-content: space-between;

`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 600px ) {
    max-width: 500px;
    width: 500px;
    min-width: 500px;
  }
`

const MainSectionForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`
const FullNameSection = styled.div`
  justify-content: stretch;
  gap: 1em;

  div {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

  }
`
export default AddUserModal